
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useTranslation } from '@/hooks/useTranslation';
import { useIsMobile } from '@/hooks/use-mobile';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import HowItWorks from '@/components/HowItWorks';
import FeaturesSection from '@/components/FeaturesSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import PricingSection from '@/components/PricingSection';
import DemoVideo from '@/components/DemoVideo';
import FAQSection from '@/components/FAQSection';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';
import { supabase } from '@/integrations/supabase/client';

const LandingPage = () => {
  const { direction } = useLanguage();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();

  // No longer auto-redirect to dashboard
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await supabase.auth.getSession();
        // Authentication check only, no auto-redirect to dashboard
      } catch (error) {
        console.error('Authentication check failed:', error);
      }
    };
    
    checkAuth();
  }, [navigate]);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Add smooth scrolling for mobile
  useEffect(() => {
    if (isMobile) {
      document.documentElement.style.scrollBehavior = 'smooth';
      
      return () => {
        document.documentElement.style.scrollBehavior = '';
      };
    }
  }, [isMobile]);

  return (
    <div className={`${direction === 'rtl' ? 'rtl' : 'ltr'} ${isMobile ? 'mobile-view' : ''}`}>
      <Navbar />
      <main>
        <HeroSection />
        <HowItWorks />
        <FeaturesSection />
        <TestimonialsSection />
        <DemoVideo />
        <PricingSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
